module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ihfRi"))).then(() => parcelRequire('f4eak'));